import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListMaterialRequests extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/material-requests/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Number',
        dataIndex: 'number'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Status Date',
        dataIndex: 'updated_date'
      }
    ]
  }

  getData = () => {
    const { materialRequests } = this.props

    const data = materialRequests.map((materialRequest, index) => {
      // format date from db
      materialRequest.updated_date = moment(new Date(materialRequest.updated_date)).format(
        'YYYY-MM-DD'
      )
      const returnObj = Object.assign(
        {
          key: `${materialRequest.id}${index}`,
          job: {
            job_id: materialRequest.job_id,
            job_type: materialRequest.job_type,
            id: materialRequest.id
          }
        },
        materialRequest
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>Material Requests</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListMaterialRequests



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListMaterialRequests.js